import { useEffect, useState } from "react";
import { Alert } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import type { WirePaymentErrors } from "./useWirePaymentsTable";

type WireTableErrorSummaryProps = {
  clickedNext: boolean;
  rowErrors: Record<number, WirePaymentErrors>;
  rowCount: number;
};

const WireTableErrorSummary = ({
  clickedNext,
  rowErrors,
  rowCount,
}: WireTableErrorSummaryProps) => {
  const { l10n } = useLocalization();
  const [errorMessages, setErrorMessages] = useState<string>("");

  const getErrorMessages = () => {
    const messages: string[] = [];

    if (rowCount === 0) {
      messages.push(
        l10n.getString("wire-payments-table-error-no-payments")
      );
    }

    let recipientError = "";
    let reasonError = "";
    let memoError = "";
    let amountError = "";

    Object.values(rowErrors).forEach((errors) => {
      if (!errors) return;
      if (errors.recipient && !recipientError) {
        recipientError = errors.recipient;
      }
      if (errors.wire_reason && !reasonError) {
        reasonError = errors.wire_reason;
      }
      if (errors.memo && !memoError) {
        memoError = errors.memo;
      }
      if (errors.amount && !amountError) {
        amountError = errors.amount;
      }
    });

    if (recipientError) messages.push(recipientError);
    if (reasonError) messages.push(reasonError);
    if (memoError) messages.push(memoError);
    if (amountError) messages.push(amountError);

    return messages.map((m) => `- ${m}`).join("\n");
  };

  useEffect(() => {
    if (clickedNext) {
      setErrorMessages(getErrorMessages());
    }
  }, [clickedNext, rowErrors, rowCount]);

  if (!clickedNext || (rowCount > 0 && Object.keys(rowErrors).length === 0)) return null;

  return (
    <div
      className={errorMessages.length ? "margin--top--xl" : ""}
      style={{ border: "1px solid var(--color-errorDark)", borderRadius: "4px" }}
    >
      <Alert
        isActive={Boolean(errorMessages)}
        kind="error"
        isDismissable={false}
      >
        {l10n.getString("wire-payments-table-error-summary-header")}
        <div style={{ whiteSpace: "pre-wrap" }}>{errorMessages}</div>
      </Alert>
    </div>
  );
};

export default WireTableErrorSummary;
